import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import Dateyear from "../Yearcontent/Yearcontent";
const FooterPage = () => {
  return (
    <>
      <div className="footer">
        <div className="footer_flex">
          <div className="products footer_flex_cont">
            <h2>Products</h2>
            <ul style={{ paddingLeft: 0 }}>
              <li>
                <Link to="/ecommerce-website-development" title="digital Commerce">
                E-commerce WebSite
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/crm-software" title="Office ERM">
                CRM

                </Link>
              </li>
              <li>
                {" "}
                <Link to="/erp-software" title="ERPpage">
                ERP

                </Link>
              </li>
              <li>
                {" "}
                <Link to="/biometric-attendance" title="BiometricPage">
                  BioMetric Based HRM
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/school-erp" title="Mini Banking">
                School ERP
                </Link>
              </li>
              <li>
                <Link to="/gold-loan-software" title="Gold Loan Management">
                  Gold Loan Management
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/matrimonial-website-development" title="Medical Billing">
                 Matrimonial Website
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/medical-billing-software" title="Medical Billing">
                  Medical Billing
                </Link>
              </li>
              {/* <li>
                {" "}
                <Link to="/TravelERPPage" title="Travel ERP">
                  Travel ERP
                </Link>
              </li> */}
              <li>
                {" "}
                <Link to="/mini-banking-software" title="pos_billing">
                Mini Banking

                </Link>
              </li>
            </ul>
          </div>
          <div className="services footer_flex_cont">
            <h2>Services</h2>
            <ul style={{ paddingLeft: 0 }}>
              <li>
                <Link
                  to="/website-design-development"
                  title="Website Design and Development"
                >
                  Website Design and Development
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/web-application-development" title="Customized web">
                Web Application Development
                </Link>
              </li>
                <li>
                <Link to="/customize-application-development" title="Android">
                  Customize Application Development
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/web-hosting-services" title="Web hosting">
                  Web Hosting
                </Link>
              </li>
              <li>
                <Link to="/android-app-development" title="Android">
                  Mobile Application Development
                </Link>
              </li>
              {/* <li>
                <Link to="/IOSPage" title="ios">
                  IOS Application Development
                </Link> */}
              {/* </li> */}
              <li>
                <Link to="/bulk-sms-services" title="Bulk SMS">
                  Bulk SMS
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/digital-marketing-services" title="HRM">
                  Digital Marketing
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/data-analytics-services" title="HRM">
                Data Analyst
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/seo-services" title="ERP">
                  SEO
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/youtube-instagram-ads" title="CRM">
                  Youtube & Insta Ads
                </Link>
              </li>
            </ul>
          </div>
          <div className="contact footer_flex_cont">
            <h2>Contacts</h2>
            <ul style={{ paddingLeft: 0 }}>
              <li>No.70/77,1st floor, Krishna complex,</li>
              <li>Kattor Road,Papanaickenpalayam, </li>
              <li>Coimbatore-641037, </li>
              <li>Tamil Nadu</li>
              <li>
                Phone :<span style={{ color: "#ffffff" }}> 0422 495 7272</span>
              </li>
              <li>
                Mobile :<span style={{ color: "#ffffff" }}> 7010816299</span>
              </li>
              <li style={{ color: "#ffffff" }}>
                kitkatsoftwaretechnologies@gmail.com
              </li>
            </ul>
          </div>
        </div>
        <div className="footer_line"></div>
        <div className="footer_copy">
          <Dateyear />
        </div>
      </div>
    </>
  );
};
export default FooterPage;
